import { Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class IsCartEmptyService {
  isCartEmpty: BehaviorSubject<boolean>=new BehaviorSubject(this._cookie.check("cartId"))
  isCartEmpty$:Observable<boolean>= this.isCartEmpty.asObservable();
  constructor(private _cookie: CookieService) { }
  isRemove(){
    this.isCartEmpty.next(this._cookie.check("cartId"));
  }
}
